import { DatePipe, JsonPipe, NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, Signal, WritableSignal, computed, signal } from '@angular/core';
import { RouterLink } from '@angular/router';
import { RxFor } from '@rx-angular/template/for';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { DataViewModule } from 'primeng/dataview';
import { PanelModule } from 'primeng/panel';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { TripStaffingService } from 'src/app/api';
import { JournalHomeTrip, TripJournalService } from 'src/app/api/trip-journal.service';
import { LocalAuthService } from 'src/app/auth/local-auth.service';
import { ContactCardUrlPipe } from 'src/app/ui/pipes/contact-card-url.pipe';
import { LocationDisplayPipe } from 'src/app/ui/pipes/location-display.pipe';
import { YoutubeEmbedComponent } from 'src/app/ui/youtube-embed/youtube-embed.component';


@Component({
  selector: 'app-trip-journals-home',
  standalone: true,
  imports: [DataViewModule, NgClass, DatePipe, CardModule, ContactCardUrlPipe, ButtonModule, RouterLink, LocationDisplayPipe, ScrollPanelModule, YoutubeEmbedComponent, PanelModule],
  templateUrl: './trip-journals-home.component.html',
  styleUrl: './trip-journals-home.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TripJournalsHomeComponent implements OnInit {



  constructor(
    private tripJournalService: TripJournalService,
    private tripStaffingService: TripStaffingService,
    private auth: LocalAuthService
  ) { }

  

  recentTrips: WritableSignal<JournalHomeTrip[]> = signal([])
  currentTrips: WritableSignal<JournalHomeTrip[]> = signal([])

  myTripIds: Signal<number[]> = computed(() => {

    const user = this.auth.currentUser
    const recentTrips = this.recentTrips()
    const currentTrips = this.currentTrips()

    if (user === null) {
      return []
    }
    else {
      return [...recentTrips, ...currentTrips]
      .filter(t => this.tripStaffingService.getStaffIdsForTrip(t).includes(user.newstaffId))
      .map(t => t.id)
    }

    
  })

  ngOnInit(): void {
    this.tripJournalService.getTripJournalHomeTrips().subscribe(results => {
      
      const recentTrips = results.map(t => (
        {...t, myTrip: this.tripStaffingService.isStaffConfirmedForTrip( this.auth.currentUser?.newstaffId ?? -1, t)}))
        .filter(t => t.tripEndDate < new Date())
        .sort((a, b) => a.myTrip ? -1 : 1)

      const currentTrips = results.map(t => (
        {...t, myTrip: this.tripStaffingService.isStaffConfirmedForTrip( this.auth.currentUser?.newstaffId ?? -1, t)}))
        .filter(t => t.tripEndDate >= new Date())
        .sort((a, b) => a.myTrip ? -1 : 1)


      
      this.recentTrips.set(recentTrips)
      this.currentTrips.set(currentTrips)

      this.recentTrips().forEach(t => {

      })

    }
    )


  }


}
